import { getAnalytics, logEvent, setUserId, setUserProperties } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getPerformance, trace } from 'firebase/performance';
import config from '../config.web';

const firebaseConfig = {
  apiKey: config.FB_API_KEY,
  authDomain: config.FB_AUTH_DOMAIN,
  projectId: config.FB_PROJECT_ID,
  storageBucket: config.FB_STORAGE_BUCKET,
  messagingSenderId: config.FB_MESSAGING_SENDER_ID,
  appId: config.FB_APP_ID,
  measurementId: config.FB_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

const performance = getPerformance(app);
performance.app.automaticDataCollectionEnabled = true;
performance.dataCollectionEnabled = true;

export { analytics, logEvent, setUserId, setUserProperties, performance, trace };
